import "./EditPartnerLabelPopup.html";
import "./EditPartnerLabelPopup.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditPartnerLabelPopupComponentController from "./EditPartnerLabelPopupComponentController";

export default class EditPartnerLabelPopupComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            labels: "<",
            resolve: "<",
        };
        this.controller = EditPartnerLabelPopupComponentController;
        this.templateUrl = "/App/Components/Partners/Details/PartnerLabels/EditPartnerLabel/EditPartnerLabelPopup.html";
    }
}

module("mmManagePortal").component("irEditPartnerLabelPopup", new EditPartnerLabelPopupComponent());
